module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-splitter"
  }, [_c('div', {
    staticClass: "splitter-handle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ae558af"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vertical-splitter.vue
// module id = 330
// module chunks = 1